import React from 'react'
import PropTypes from 'prop-types'

import { Motion, Wrapper } from 'Components/UI'
import { Text } from 'Components/UI/_Legacy'

import isEmpty from 'lodash/isEmpty'
import map from 'lodash/map'

import { PROJECTS_DATA } from 'Constants/Projects/projectAdditionalData'

import Participant from './participant'
import { Container, Content } from './styles'

function Team({ projectId }) {
  const project = PROJECTS_DATA.find(item => item.projectId === projectId)

  if (isEmpty(project) || isEmpty(project.team)) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h2" legacyTitle lineHeight={1} mb={[16, 16, 48]}>
          Team
        </Text>

        <Content>
          {map(project.team, entity => (
            <Motion key={entity?.fullName}>
              <Participant data={entity} />
            </Motion>
          ))}
        </Content>
      </Wrapper>
    </Container>
  )
}

Team.defaultProps = {
  projectId: '',
}

Team.propTypes = {
  projectId: PropTypes.string,
}

export default Team
